// @ts-strict-ignore
import type { Module } from 'vuex'

import type { MessagesState } from '../../models'

import { LocaleEnum } from '../../enums'

import { SetLocaleAction } from '../../store/messages/actions/set-locale.action'
import { LocaleGetter } from '../../store/messages/getters/locale.getter'
import { MessagesGetter } from '../../store/messages/getters/messages.getter'
import { MESSAGES_CONSTS } from '../../store/messages/messages.consts'
import { SetLocaleMutation } from '../../store/messages/mutations/set-locale.mutation'

export const MESSAGES_MODULE: Module<MessagesState, any> = {
  namespaced: true,

  initialState: (): MessagesState => ({
    locale: LocaleEnum.ENGLISH,
    fallbackLocale: LocaleEnum.ENGLISH,
  }),
  state: (): MessagesState => MESSAGES_MODULE.initialState(),

  getters: {
    [MESSAGES_CONSTS.getters.locale]: LocaleGetter.execute,
    [MESSAGES_CONSTS.getters.messages]: MessagesGetter.execute,
  },

  actions: {
    [MESSAGES_CONSTS.actions.setLocale]: SetLocaleAction.execute,
  },

  mutations: {
    [MESSAGES_CONSTS.mutations.setLocale]: SetLocaleMutation.execute,
  },
}
